export default function SpecRow({

    label,

    value,

    unit = ""

}) {

    const badgeValues = [

        "Solar",
        "Solar_First",
        "Off_Grid",
        "AGM",
        "Transformerless",
        "Single_Phase"

    ];

    const badge = badgeValues.includes(value);

    return (

        <div className="specRow">

            <span className="specLabel">

                {label}

            </span>

            {

                badge ?

                (

                    <span className="specBadge">

                        {String(value).replaceAll("_"," ")}

                    </span>

                )

                :

                (

                    <span className="specValue">

                        {value} {unit}

                    </span>

                )

            }

        </div>

    );

}